/*
 * Forge Maestro
 * (c) Honeywell
 */

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { IconBase } from '../IconBase.js';
import { IconName } from '../IconName.enum.js';

const CloseIcon = forwardRef((props, ref) => {
    const { className = '', title, strokeWidth = 1.5 } = props;
    return (jsx(IconBase, Object.assign({ ref: ref, className: className, title: title, name: IconName.Close }, { children: jsx("path", { strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", d: "M21 3 3 21M3 3l18 18" }) })));
});

export { CloseIcon };
//# sourceMappingURL=CloseIcon.js.map
